
import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";

import MaterialIssueService from "../../../../core/service/MaterialIssueService";
import { MaterialityImpactType, MaterialityType } from "../../../../core/constants/common";

const QuestionScoreModal = ({ t,
	title,
	questionId,
	companyId,
	stakeholderGroupId,
	matertialityType,
	onClose
}) => {

	const [scores, setScores] = useState([]);

	useEffect(() => {

		MaterialIssueService.getScoreForQuestion(companyId, questionId, stakeholderGroupId).then(res => {
			if (res.status !== 200) return;

			const groupedData = {};
			res.data?.forEach(entry => {
				const id = entry.stakeholder.id;
				if (!groupedData[id]) {
					groupedData[id] = {
						name: entry.stakeholder.name,
						email: entry.stakeholder.email,
						finance: null,
						impact: null,
						importance: null,
						comments: entry.comments,
						category: entry.stakeholder.category,
						group: entry.stakeholder.groupName
					};
				}
				if (entry.impactType === MaterialityImpactType.FINANCIAL) {
					groupedData[id].finance = entry.score;
				} else if (entry.impactType === MaterialityImpactType.IMPACT) {
					groupedData[id].impact = entry.score;
				} else if (entry.impactType === MaterialityImpactType.IMPORTANCE) {
					groupedData[id].importance = entry.score;
				}
			});
			setScores(Object.values(groupedData));
		}).catch(err => { });
	}, []);


	return (
		<Modal show={true}
			onHide={onClose}
			size="xl"
			aria-labelledby="contained-modal-title-vcenter"
			centered backdrop="static"
			keyboard={false}>
			<Modal.Header closeButton className='border-0'>
				<Modal.Title as="h5">{title} [{scores[0]?.category ? scores[0]?.category : ''} / {scores[0]?.group ? scores[0]?.group : ''}]</Modal.Title>
			</Modal.Header>
			<Modal.Body className='pt-2'>
				<div className='ScoreCardbox_table mt-2'>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>{t('StakeholderName.label')}</th>
								<th>{t('Email.label')}</th>
								{ matertialityType === MaterialityType.DOUBLE && <th>{t('Financial.label')}</th> }
								{ matertialityType === MaterialityType.SINGLE && <th>{t('Importance.label')}</th> }
								<th>{t('Impact.label')}</th>
								<th>{t('Comments.label')}</th>
							</tr>
						</thead>					
						<tbody>
							{
								scores.map((score, index) => {
									return (
										<tr key={`qscore-${index}`}>
											<td>{score.name}</td>
											<td>{score.email}</td>
											{ matertialityType === MaterialityType.DOUBLE && <td>{score.finance}</td>}
											{ matertialityType === MaterialityType.SINGLE && <td>{score.importance}</td>}
											<td>{score.impact}</td>
											<td>{score.comments}</td>
										</tr>
									)
								})
							}
						</tbody>
					</Table>
				</div>				
			</Modal.Body>
		</Modal>
	);
};

export default withTranslation()(QuestionScoreModal);


